import { z } from 'zod'
import type { IntegrationERPSettings } from '../../models/IntegrationERPSettings'

export const IntegrationERPSettingsDTO = z.object({
  is_allowed_system_generate_secure_integration_key: z.boolean()
})

export type IntegrationERPSettingsDTO = z.infer<typeof IntegrationERPSettingsDTO>

export function mapIntegrationERPSettingsToDTO (model: IntegrationERPSettings): IntegrationERPSettingsDTO {
  return {
    is_allowed_system_generate_secure_integration_key: model.isAllowedSystemGenerateSecureIntegrationKey
  }
}

export function mapDTOToIntegrationERPSettings (dto: IntegrationERPSettingsDTO): IntegrationERPSettings {
  return {
    isAllowedSystemGenerateSecureIntegrationKey: dto.is_allowed_system_generate_secure_integration_key
  }
}
